import axios from 'axios';

import config from '../config';

import StorageHelper from '../helpers/StorageHelper';
import { interceptorAddToken, queryString } from './Api';

const ApiV2 = axios.create({
  baseURL: config.urlApiV2,
  paramsSerializer: queryString,
  headers: { public_token: config.apiV2PublicToken },
});

ApiV2.interceptors.request.use((config) =>
  interceptorAddToken(config, {
    headerName: 'user_token',
    tokenPrefix: '',
    token: StorageHelper.getTokenApiV2(),
  }),
);

export default ApiV2;
